/**
 * This filter returns a url that is trusted by AngularJS
 * @param ngModule
 */
export default
function(ngModule) {
    ngModule.filter('trustUrl', ['$sce', function ($sce) {
            return function(url) {
                return $sce.trustAsResourceUrl(url);
            };
        }]);
}



// WEBPACK FOOTER //
// ./source/filters/TrustUrlFilter.js